import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import Image from "@/components/common/Image";
import {IMAGE_FALLBACK} from "@/constants";
import React, {useMemo} from "react";
import useDevice from "@/hooks/useDevice";
import GridContainer from "@/components/common/GridContainer";
import BannerCard from "@/components/Banners/SubPage/Components/BannerCard";
import AssetWrapper from "@/components/Banners/SubPage/Components/AssetWrapper";

const Wrapper = styled.section`
    //overflow: hidden;
    position: relative;
    height: 100svh;
	//height: 100vh;
	width: 100%;
    display: flex;
    align-items: flex-end;
    padding-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
    	padding-bottom: ${getCssSizeValue(48)};
    }
`;

const StyledGridContainer = styled(GridContainer)`
	position: relative;
	z-index: 1;
	align-items: end;
`

export default function CardAndImageVariant({ data }) {
	const orientation = useDevice('orientation')

	const image = useMemo(() => {
		const image = orientation === 'landscape' ? data?.image : data?.imageVertical
		return image || data?.image || IMAGE_FALLBACK
	},[orientation, data])

	return (
		<Wrapper>
			<AssetWrapper>
				<Image
					src={image.url}
					alt={image.alt}
					priority
					placeholder={image.blurUpThumb}
					focalPoint={image.focalPoint}
					sizes="100vw"
					quality={90}
				/>
			</AssetWrapper>

			<StyledGridContainer>
				<BannerCard data={data} />
			</StyledGridContainer>
		</Wrapper>
	)
}
